import loadable from "@loadable/component";

const NotFound = loadable(() => import("pages/NotFound"));

export default {
  NotFound,
};
